import type { TemplateOnlyComponent } from '@ember/component/template-only'
import RouteTemplate from 'ember-route-template'
import { BlogPosts } from 'teacher-ui-client/components/contentful/blog-posts'
import type { BlogPostEntries } from 'teacher-ui-client/subscription-type/blog/index/route.ts'

interface BlogTemplateArgs {
  model: BlogPostEntries
}

const BlogTemplate: TemplateOnlyComponent<BlogTemplateArgs> = <template>
  <div class="m-0 w-full grow">
    <BlogPosts @model={{@model}} />
  </div>
</template>

export default RouteTemplate(BlogTemplate)
